import { groupBy, head, isNil, values } from 'lodash';
import { action, computed, extendObservable } from 'mobx';
import FetchService from '../../../../core/services/FetchService';
import { formatValueByIndicator, formatIndicator, getAverageByIndicator } from './utils';

class CustomerSuccessHistoryService {
  fetch = new FetchService();

  constructor() {
    extendObservable(this, {
      isOpen: false,
      indicator: null,
      company: null,
      data: [],
      history: computed(() => {
        if (!this.data) return [];

        let data = this.data;
        if (this.company) {
          data = this.data.filter((item) => item.company.id === this.company);
        }

        const groupByReferenceMonth = values(groupBy(data, 'referenceMonth'));
        return groupByReferenceMonth.map((monthData) => ({
          referenceMonth: head(monthData).referenceMonth,
          value:
            getAverageByIndicator(monthData, this.indicator) / (this.indicator === 'STUDENT_ENGAGEMENT' ? 3600 : 1),
        }));
      }),
    });
  }

  getFormattedValue = (indicator, value) => formatValueByIndicator(indicator, value);

  getFormattedIndicator = (indicator) => formatIndicator(indicator);

  closeDialog = action(() => {
    this.isOpen = false;
    this.indicator = null;
  });

  openDialog = action((indicator, company) => {
    this.isOpen = true;
    this.indicator = indicator;
    this.company = company;
    this.load();
  });

  load = action(() => {
    this.fetch
      .fetch({
        url: '/kpis/customer-success',
        query: {
          indicator: this.indicator,
        },
      })
      .then(() => {
        if (this.fetch.data) {
          this.data = this.fetch.data.filter((x) => !isNil(x.value));
        } else {
          this.data = [];
        }
      });
  });
}

const customerSuccessHistoryService = new CustomerSuccessHistoryService();
export default customerSuccessHistoryService;
